export const STEPS = {
  signUp: 'sign_up',
  enterPhone: 'enter_phone',
  verifyPhone: 'verify_phone',
  selectGenre: 'select_genre',
};
